import React, { useContext, useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import RefreshIcon from "../../images/Refreshimg.svg";

import { useTranslation } from "react-i18next";
import { getbannerandTemplateDetails, getMLRstatus } from "../../services/apis";
import "../../styles/pages/Banners/BannerManager.scss";
import ValueContext from "../../ContextAPi/appContext";
import Button from "@material-ui/core/Button";
import CopyImage from "../../images/CopyImage.svg";

import lockCircled from "../../images/lockCircled.svg";
import { CircularProgress } from "@material-ui/core";
import { banner } from "../../Uitls/constants";
import Tooltip from "@material-ui/core/Tooltip";

export default function BannerAndTemplateDetailsModal(props) {
  const {
    setShowDetails,
    showDetails,
    bannerDetails,
    setBannerDetails,
    lockStatus,
    historyprops,
    recentlyViewedData,
  } = props;
  const appData = useContext(ValueContext);

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setShowDetails(false);
    setBannerDetails({});
  };

  useEffect(() => {
    getLatestMLRStatus(props?.recentlyViewedData?.id);
  }, []);

  const getLatestMLRStatus = (id) => {
    setLoading(true);

    getMLRstatus(id, async (response, err, errorCode) => {
      if (err) {
        // const errCoponent = errComponentToRender(errorCode);

        setLoading(false);
      } else {
        setLoading(false);
        const data = await response.data;
        setBannerDetails({
          ...bannerDetails,
          reviewStatus: data?.reviewStatus || "Not submitted",
        });
      }
    });
  };

  const showCreatedOntime = (createdTime) => {
    const date = new Date(createdTime);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();

    return `${day}/${month}/${year}`;
  };

  function convertTimestamp(timestamp) {
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    const originaldate = `${day}/${month}/${year}`;

    const convertedTime = `${formatNumber(date.getHours())}:${formatNumber(
      date.getMinutes()
    )}:${formatNumber(date.getSeconds())} hrs`;
    const convertedTimestamp = `${originaldate}, ${convertedTime}`;
    return convertedTimestamp;
  }
  const formatNumber = (num) => {
    return num < 10 ? `0${num}` : num;
  };
  const bannerLink = (assetId) => {
    let url = window.location.origin;
    const editorLink = `${url}/banner-editor/${assetId}`;

    return editorLink;
  };

  return (
    <>
      <Dialog
        disableBackdropClick
        open={showDetails}
        onClose={handleClose}
        className="details-modal detilsDialog"
        id="details-modal"
        aria-labelledby="form-dialog-title"
        overlayStyle={{ backgroundColor: "transparent" }}
      >
        {loading && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />{" "}
          </>
        )}
        <div className=" bannerRow customScrollbar">
          <div className="leftBox ">
            <div className="innerLeftbox">
              <DialogTitle id="form-dialog-title" className="bannerInfo">
                <div className="details-modalheading">
                  {t("Banner Information")}
                </div>
              </DialogTitle>

              <>
                <Tooltip title={bannerDetails?.assetName} placement="top">
                  <div
                    className="d-flex contentrow  "
                    style={{ paddingTop: "10px" }}
                  >
                    <div className="details-modalContent">Name</div>{" "}
                    <div className="contentban">{bannerDetails?.assetName}</div>{" "}
                  </div>
                </Tooltip>
                <div className="d-flex contentrow">
                  <div className="details-modalContent">Type</div>{" "}
                  <div className="contentban">
                    {bannerDetails?.isAnimated === true ? "Animated" : "Static"}
                  </div>{" "}
                </div>

                <div className="d-flex contentrow">
                  <div className="details-modalContent">Brand</div>{" "}
                  <div className="contentban">{bannerDetails?.brandName}</div>{" "}
                </div>

                <div className="d-flex contentrow">
                  <div className="details-modalContent">Banner link</div>{" "}
                  {recentlyViewedData.madeBy === "me" ||
                  recentlyViewedData.lockStatus === "Unlocked" ? (
                    <div className="contentbannerlink d-flex">
                      <>
                        <img
                          src={CopyImage}
                          alt=""
                          style={{ cursor: "pointer", marginTop: "-18px" }}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              bannerLink(recentlyViewedData.id)
                            );
                          }}
                        />
                        <div className="banenrLink">
                          <Tooltip
                            title={bannerLink(recentlyViewedData.id)}
                            placement="top"
                          >
                            <a
                              href={bannerLink(recentlyViewedData.id)}
                              target="blank"
                            >
                              {" "}
                              {bannerLink(recentlyViewedData.id)}
                            </a>
                          </Tooltip>
                        </div>{" "}
                      </>
                    </div>
                  ) : (
                    <div className="contentbannerlink lockedlink">
                      <>
                        <Tooltip
                          title={bannerLink(recentlyViewedData.id)}
                          placement="top"
                        >
                          <div className="banenrLink">
                            {bannerLink(recentlyViewedData.id)}
                          </div>
                        </Tooltip>
                      </>
                      <div className="d-flex">
                        <img src={lockCircled} alt="" />
                        <span className="lockmessage">Banner is locked</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="d-flex contentrow">
                  <div className="details-modalContent">Market</div>{" "}
                  <div className="contentban">{bannerDetails?.marketName}</div>{" "}
                </div>
                <div className="d-flex contentrow">
                  <div className="details-modalContent">Size</div>{" "}
                  <div className="contentban">
                    {bannerDetails?.width} x {bannerDetails?.height}
                  </div>{" "}
                </div>
                <Tooltip title={bannerDetails?.campaign} placement="top">
                  <div className="d-flex contentrow">
                    <div className="details-modalContent">Campaign</div>{" "}
                    <div className="contentban">
                      {/* {bannerDetails?.brandName === "— Not Brand Specific —"
                        ? "-"
                        :  */}
                      {bannerDetails?.campaign}
                    </div>{" "}
                  </div>
                </Tooltip>
                <div className="d-flex contentrow">
                  <div className="details-modalContent">DAMS ID</div>{" "}
                  <div className="contentban">
                    {bannerDetails.veevaDocNumber === null
                      ? "-"
                      : bannerDetails.veevaDocNumber}
                  </div>{" "}
                </div>
                <div className="d-flex contentrow">
                  <div className="details-modalContent">MLR Status</div>{" "}
                  <div className="contentban d-flex">
                    <img
                      src={RefreshIcon}
                      alt=""
                      className="img-fluid refreshIcondetails"
                      onClick={(e) =>
                        getLatestMLRStatus(props?.recentlyViewedData?.id)
                      }
                    />
                    {bannerDetails?.reviewStatus === null
                      ? "Not submitted"
                      : bannerDetails?.reviewStatus}
                  </div>{" "}
                </div>
              </>
              <div className=" contentrow2">
                <div className="d-flex contentrowcreatedby">
                  <div className="details-modalContent2">Created by</div>{" "}
                  <div className="content">{bannerDetails?.createdByName}</div>{" "}
                </div>
                <div className="d-flex contentrowcreatedby">
                  <div className="details-modalContent2">Created on</div>{" "}
                  <div className="content">
                    {showCreatedOntime(bannerDetails?.createdDateTime)}
                  </div>{" "}
                </div>
                <div className="d-flex contentrowcreatedby">
                  <div className="details-modalContent2">Last modified by</div>{" "}
                  <div className="content">{bannerDetails.updatedByName}</div>{" "}
                </div>
                <div className="d-flex contentrowcreatedby">
                  <div className="details-modalContent2">Last modified on</div>{" "}
                  <div className="content">
                    {convertTimestamp(bannerDetails?.updatedDateTime)}
                  </div>{" "}
                </div>
              </div>
              {/* <div className="d-flex contentrow">
                <div className="details-modalContent">{t("Type")}</div>{" "}
                <div className="content">Static</div>{" "}
              </div> */}
            </div>
          </div>
          <div className="rightbox srctemplateInfo">
            <DialogTitle id="form-dialog-title">
              <div className="details-modalheading">
                {t("Source Template Information")}
              </div>
            </DialogTitle>

            <>
              <Tooltip
                title={bannerDetails?.sourceTemplateInfo?.assetName}
                placement="top"
              >
                <div
                  className="d-flex contentrowcreatedby "
                  style={{ paddingTop: "10px" }}
                >
                  <div className="details-modalContent2">Name</div>{" "}
                  <div className="contentban">
                    {bannerDetails?.sourceTemplateInfo !== null
                      ? bannerDetails?.sourceTemplateInfo?.assetName
                      : "-"}
                  </div>{" "}
                </div>
              </Tooltip>
              <Tooltip
                title={bannerDetails?.sourceTemplateInfo?.brandName}
                placement="top"
              >
                <div className="d-flex contentrowcreatedby">
                  <div className="details-modalContent2">Brand</div>{" "}
                  <div className="contentban">
                    {bannerDetails?.sourceTemplateInfo !== null
                      ? bannerDetails?.sourceTemplateInfo?.brandName
                      : "-"}
                  </div>{" "}
                </div>
              </Tooltip>
              <div className="d-flex contentrowcreatedby">
                <div className="details-modalContent2"> Market</div>{" "}
                <div className="contentban">
                  {bannerDetails?.sourceTemplateInfo !== null
                    ? bannerDetails?.sourceTemplateInfo?.marketName
                    : "-"}
                </div>{" "}
              </div>
              <Tooltip
                title={bannerDetails?.sourceTemplateInfo?.campaign}
                placement="top"
              >
                <div className="d-flex contentrowcreatedby">
                  <div className="details-modalContent2">Campaign</div>{" "}
                  <div className="contentban">
                    {bannerDetails?.sourceTemplateInfo !== null
                      ? bannerDetails?.sourceTemplateInfo?.campaign
                      : "-"}
                  </div>{" "}
                </div>
              </Tooltip>
              <div className="d-flex contentrowcreatedby">
                <div className="details-modalContent2">Created by</div>{" "}
                <div className="contentban srctemp">
                  {bannerDetails?.sourceTemplateInfo !== null
                    ? bannerDetails?.sourceTemplateInfo?.cratedByName
                    : "-"}
                </div>{" "}
              </div>
              <div className="d-flex contentrowcreatedby">
                <div className="details-modalContent2">Created on</div>{" "}
                <div className="contentban srctemp">
                  {bannerDetails?.sourceTemplateInfo !== null
                    ? showCreatedOntime(
                        bannerDetails?.sourceTemplateInfo?.createdDateTime
                      )
                    : "-"}
                </div>{" "}
              </div>
            </>
          </div>
        </div>
        <DialogActions className="delete-actionss">
          <Button onClick={handleClose} color="primary" className="no-btn">
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
